import { LegalList, LegalPage, LegalSection } from './LegalPage'

/** 문의를 받을 자리. 공개하기 전에 실제 값으로 채운다. */
const CONTACT = '운영자 연락처를 여기에 적는다'

export function PrivacyPage() {
  return (
    <LegalPage title="개인정보 처리방침" effectiveDate="2026년 8월 28일">
      <LegalSection heading="가장 먼저 알아야 할 것">
        <p>
          mlog가 다루는 것은 마음에 대한 기록이에요. 새면 피해가 큰 정보라 처음부터 적게 받고 강하게
          잠가 두는 것을 원칙으로 삼았어요.
        </p>
        <p>
          기록 본문과 이메일은 데이터베이스에 암호문으로만 저장해요. 저장소 사본이 통째로 새더라도
          그 안의 내용은 읽히지 않아요.
        </p>
      </LegalSection>

      <LegalSection heading="무엇을 받나요">
        <p>계정을 만들 때 로그인한 곳에서 두 가지만 받아요.</p>
        <LegalList
          items={[
            '로그인한 곳의 계정에 등록된 이메일 주소',
            '로그인한 곳이 그 계정에 붙인 회원 식별자',
          ]}
        />
        <p>
          구글은 두 값을 로그인할 때 받는 토큰에 담아 줘요. 네이버는 식별자만 토큰에 담고 이메일은
          회원 정보 API를 한 번 불러야 알려줘요. 그래서 네이버로 가입할 때만 그 API를 부르고 이메일
          하나만 꺼내요.
        </p>
        <p>
          실명과 성별, 생년월일, 프로필 사진은 로그인한 곳이 주더라도 저장하지 않아요. 로그인한 곳이
          발급한 토큰은 그 자리에서 한 번 쓰고 버려요. 저장하지 않고 브라우저로 내리지도 않아요.
        </p>
        <p>서비스를 쓰는 동안에는 기록과 그에 딸린 최소한의 값이 쌓여요.</p>
        <LegalList
          items={[
            '기록 본문',
            '작성 시각과 무드, 태그',
            '기록을 바탕으로 만든 감정 해석',
            '로그인 상태를 유지하는 Session 정보',
          ]}
        />
      </LegalSection>

      <LegalSection heading="어디에 쓰나요">
        <LegalList
          items={[
            '기록을 저장하고 다시 보여주는 일',
            '로그인 상태를 유지하고 본인만 자기 기록에 닿게 하는 일',
            '기록을 바탕으로 감정 해석과 통계를 만드는 일',
            '장애를 찾아 고치고 서비스를 안전하게 지키는 일',
          ]}
        />
        <p>광고에 쓰지 않고 다른 사람에게 팔지 않아요.</p>
      </LegalSection>

      <LegalSection heading="어떻게 지키나요">
        <LegalList
          items={[
            '기록 본문과 이메일은 애플리케이션이 암호화해 암호문으로만 저장해요.',
            '브라우저와 서버 사이 구간은 전부 암호화한 연결로 오가요.',
            'Session은 자바스크립트가 읽지 못하는 쿠키로 두고 일정 시간이 지나면 끊겨요.',
            '로그와 오류 기록에 기록 본문과 이메일을 남기지 않아요.',
            '자기 기록에 닿을 수 있는 사람은 본인뿐이에요. 이 판정은 서버가 매 요청마다 해요.',
          ]}
        />
      </LegalSection>

      <LegalSection heading="감정 해석은 어디서 처리하나요">
        <p>
          감정 해석은 운영자가 직접 굴리는 처리 환경에서 돌아요. 지금은 기록을 외부 인공지능
          서비스에 보내지 않아요.
        </p>
        <p>
          나중에 외부 서비스를 쓰게 되면 어디로 무엇이 나가는지, 학습에 쓰이지 않는다는 조건을
          어떻게 걸었는지 미리 알리고 동의를 받을게요.
        </p>
      </LegalSection>

      <LegalSection heading="다른 곳에 넘기나요">
        <p>
          기록을 제3자에게 제공하지 않아요. 로그인할 때 구글이나 네이버가 본인 확인을 해 주지만, 그
          과정에서 mlog가 그곳에 기록을 보내지는 않아요.
        </p>
        <p>
          상담사에게 기록의 일부를 골라 보여주는 기능을 나중에 만들 생각이에요. 그 기능은 본인이
          무엇을 누구에게 얼마 동안 보여줄지 직접 고르기 전에는 아무것도 나가지 않게 만들 거예요.
        </p>
      </LegalSection>

      <LegalSection heading="얼마나 두나요">
        <p>
          기록은 지울 때까지 두어요. 계정을 지우면 기록과 감정 해석, 계정 정보를 실제로 삭제해요.
          장애에 대비해 두는 백업 사본에는 잠시 남을 수 있고, 그 사본도 보관 기간이 끝나면 파기해요.
        </p>
      </LegalSection>

      <LegalSection heading="할 수 있는 일">
        <LegalList
          items={[
            '자기 기록을 언제든 보고 고치고 지울 수 있어요.',
            '계정을 지우면 남은 기록도 함께 사라져요.',
            '처리 내용이 궁금하면 아래 연락처로 물어볼 수 있어요.',
          ]}
        />
      </LegalSection>

      <LegalSection heading="방침이 바뀔 때">
        <p>
          내용을 고치면 시행일과 함께 이 화면에 올려요. 받는 정보나 쓰는 목적이 달라지는 변경은 시행
          전에 알릴게요.
        </p>
      </LegalSection>

      <LegalSection heading="문의">
        <p>{CONTACT}</p>
      </LegalSection>
    </LegalPage>
  )
}
